import { Pipe, PipeTransform } from '@angular/core';
import { IDatePlace } from '../models/location.model';
import { DateService } from '../services/date/date.service';

@Pipe({ name: 'datePlaceConversion',pure:false })
export class DatePlaceConversionPipe implements PipeTransform {
  constructor(private dateService:DateService){

  }
  transform(datePlace: IDatePlace,upperCase:boolean, long?:boolean) {
    return this.dateService.formatDatePlace(datePlace,upperCase, long, true);
  }
}